import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { getRoutes } from '../../../shared/config/routesConfig';
import { User } from '../../../shared/services/user';

const useStyles = makeStyles({
  bodyComponent: {
    gridArea: 'body-component',
    display: 'grid',
    gridTemplateAreas: `
    'main'
    'footer'
  `,
    gridTemplateRows: 'auto 20px',
    gridRowGap: '1px',
  },
  bodyMain: {
    gridArea: 'main',
    justifySelf: 'center',
    maxWidth: '1185px',
    minWidth: '1185px',
  },
  bodyFooter: {
    gridArea: 'footer',
  },
});

interface BodyComponentProps {
  user: User;
}

const BodyComponent: React.FC<BodyComponentProps> = ({ user }: BodyComponentProps) => {
  const classes = useStyles();

  const routes = getRoutes();

  return (
    <div className={classes.bodyComponent}>
      <div className={classes.bodyMain}>
        <Switch>
          {routes.map((route) => (
            <Route
              key={route.link}
              path={route.link}
              exact={!!route.exact}
              render={(props) => (route.component ? <route.component {...props} {...route.props} user={user} /> : null)}
            >
              {route.redirect && <Redirect to={route.redirect} />}
            </Route>
          ))}
        </Switch>
      </div>
      <footer className={classes.bodyFooter}>
        <p style={{ margin: '0' }}>AdeptDC Inc. All rights reserved.</p>
        <p style={{ margin: '0 15px' }}>Copyright © {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
};

export default BodyComponent;
